import { IProductionDashboardBayVehicle } from "../models/ProductionDashboard";

/**
 * Whether a vehicle sits in a stage column (Triage or Depollution) of the flow.
 *
 * The API sets currentStage only with the stages in the flow, when the vehicle's most recent
 * timer was that stage's and nothing further down the line has been touched since. There the
 * vehicle shows with its own chip - timer running, paused, or finished and waiting to move on. A
 * vehicle that has finished every assembly belongs in Completed Today rather than a stage column,
 * unless the stage timer is still running, in which case it is genuinely being worked there.
 */
export const isAtFlowStage = (
  vehicle: Pick<
    IProductionDashboardBayVehicle,
    "currentStage" | "percentComplete" | "currentAssemblyStartedOn"
  >
): boolean =>
  vehicle.currentStage != null &&
  (vehicle.percentComplete < 100 || !!vehicle.currentAssemblyStartedOn);
